<template>
	<div class="absolute">
		<!-- Swap Dialog -->
        <modal
            class="swap-modal"
            size="medium2"
            @close="close"
			:hide-footer="true">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Rundown Output') }}</h5>
            </template>
            <template slot="body">
                <!-- <h5 class="mb-2 pl-1 mt-4 text-left">{{ $t('SELECT OUTPUT(S)') }}</h5> -->
				<div class="tab-menus d-flex mb-4">
					<div class="tab-menu" :class="{ 'active': tab === 'output' }"
						@click="switchTab('output')">
						{{ $t('Display') }}
					</div>
					<div class="tab-menu"
						:class="{ 'active': tab === 'render' }"
						@click="switchTab('render')">
						{{ $t('Render') }}
					</div>
				</div>
				<!-- outputs -->
				<div v-if="tab === 'output'">
					<p class="mb-3 pl-1 text-left">{{ $t('Please select one or more') }} <span @click="goToDisplay" class="text-primary pointer">{{ $t('output') }} </span>{{ $t('for this rundown') }}</p>
					<div class="header-output-display">
						<ul class="list-nonstyle mb-1">
							<li class="display-output-list-header pl-4">
								<div class="d-flex display-outpust-list-wrapper">
									<div class="mr-9">
										{{$t('Name')}}
									</div>
									<div class="mr-5 ml-3">
										{{$t('Type/Output layer')}}
									</div>
									<div class="ml-5 pl-2">
										{{$t('Rundown')}}
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div class="display-output-list mr-2 ml-1" id="styleScroll">
						<div class="p-5 text-center" v-if="isFetching || isFetchingRundown">
							<div class="is-loading large">
							</div>
						</div>
						<div v-if="items.length > 0 && rundownId && !isFetchingRundown">
							<div v-for="(item, index) in items" :key="item.id">
								<ul class="list-nonstyle mb-1">
									<li class="display-output-list-item pl-4">
										<!-- display output name -->
										<div class="d-flex display-outpust-list-wrapper">
											<div class="display-modal-name pt-2"
											:class="{
												// check if and assigned
												'text-white': arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id === null && itemsDisplay[index].rundown_id !== rundownId,
												'disabled': arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id === null && itemsDisplay[index].rundown_id !== rundownId,
												// check if unassigned
												'text-grey': arrayDisplay[index] && arrayDisplay[index].rundown_id !== rundownId,
												// check if saving and assigned
												'text-display-output': arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId,
											}">
												<template v-if="item.name.length > 24">
													<!-- check if saving and assigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId" @click="viewDisplay(item)" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
													<!-- check if assigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id !== rundownId" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
													<!-- check if unassigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== rundownId" v-tooltip.auto-start="item.name">{{ trimDisplayName(item.name) }}</span>
												</template>
												<template v-if="item.name.length < 24">
													<!-- check if saving and assigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id !== null && itemsDisplay[index].rundown_id === rundownId" @click="viewDisplay(item)">{{ trimDisplayName(item.name) }}</span>
													<!-- check if assigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId && itemsDisplay[index] && itemsDisplay[index].rundown_id !== rundownId">{{ trimDisplayName(item.name) }}</span>
													<!-- check if unassigned -->
													<span v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== rundownId">{{ trimDisplayName(item.name) }}</span>
												</template>
											</div>
											<!-- layer index on display output -->
											<div class="text-center w-140">
												<div class="d-flex pt-2">
													<div class="ml-3 mr-2"
														:class="{
															'dot-black': item.background_color === '#000000',
															'dot-white': item.background_color === 'background:none',
															'dot-green': item.background_color === '#00FF00',
														}"
														>
													</div>
													<div v-if="item.layer_index.length <= 5" class="mr-a">
														{{ printLayerIndex(item) }}
													</div>
													<div v-tooltip.bottom-end="printLayerIndex(item)" v-if="item.layer_index.length > 10"  class="mr-a" :class="{'truncate-display-modal-index': item && item.layer_index && !printLayerIndex(item).includes('All')}">
														{{ printLayerIndex(item) }}
													</div>
												</div>
											</div>
											<!-- rundown name on display output -->
											<div class="d-flex pt-2 pr-3 text-center">
												<div class="truncate-display-modal-rundown-name">
													{{item && item.rundown && item.rundown.name ? item.rundown.name : ''}}
												</div>
											</div>
											<!-- if shared by -->
											<div style="width: 20px;">
												<div v-if="user && item.user_id !== user.id" v-tooltip.bottom-end="{ content: `Shared by ${item.user.name}` }" class="d-flex pt-1 mr-a">
													<svg style="width:24px;height:24px" viewBox="0 0 24 24">
														<path fill="#FFA800" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
													</svg>
												</div>
												<!-- if shared with -->
												<div v-if="user && item.user_id === user.id && item && item.collaborators && item.collaborators.length > 0" class="mr-a" v-tooltip.bottom-end="{ content: collaboratorList(item), classes: 'tooltip-render-displays' }">
													<svg style="width:24px;height:24px" viewBox="0 0 24 24">
														<path fill="#FFA800" d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
													</svg>
												</div>
											</div>
											<div class="button-assign pt-1 ml-4">
												<button v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== null && arrayDisplay[index].rundown_id === rundownId" class="btn btn-default btn-assign" @click="selectedDisplay(item)">{{$t('Unpublish')}}</button>
												<button v-if="arrayDisplay[index] && arrayDisplay[index].rundown_id !== rundownId" class="btn btn-primary btn-assign" @click="selectedDisplay(item)">{{$t('Publish')}}</button>
											</div>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div class="text-center mt-20" v-if="items.length === 0 && !isFetching">
							{{$t('No Display Available')}}
						</div>
					</div>
				</div>
				<!-- render -->
				<div v-if="tab === 'render'" class="display-output-render">
					<div :class="{'disabled': !userRenderSequences}">
						<p class="mb-2 pl-1 text-left" :class="{'text-secondary': !userRenderSequences}">{{ $t('Please select output settings for rundown render') }}</p>
						<md-menu md-align-trigger md-direction="bottom-start" :md-active.sync="isToggleDisplay" :class="{'disabled-w-bg': !userRenderSequences}">
							<div md-menu-trigger v-if="!selectedDisplayRender">
								<input
									type="text"
									class="form-control w-645"
									:placeholder="$t('My Display Filter')"
									v-model="keywordSearchDisplayRender"
									@click.stop="toggleDisplay()"
								/>
							</div>
							<div md-menu-trigger class="relative" v-if="selectedDisplayRender">
								<input
									type="text"
									class="form-control w-645"
									v-model="selectedDisplayRender.name"
									disabled
									@click.stop="toggleDisplay()"
								/>
								<div @click.stop="removeDisplay" class="modal-close-assets absolute delete-display-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<md-menu-content id="scrolls-style">
								<md-menu-item class="item-output-rundown" v-for="item in filteredDisplay" @click="selectDisplay(item)"
								:key="item.id">{{item.name}}</md-menu-item>
								<md-menu-item v-if="filteredDisplay.length <= 0" class="item-output-rundown">
									Oops, there is no display available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</div>
					<div class="mt-5" v-if="!userRenderSequences">
						Render feature are not available in your current subscription, <div class="text-primary pointer" @click="goToSubs">upgrade your subscription</div>
					</div>
				</div>
				<div class="d-flex justify-content-between" v-if="items.length > 0">
					<button :class="{'is-loading': isSaving}" class="btn btn-primary mt-4" @click="select()">{{$t('Save')}}</button>
					<button class="btn btn-secondary mt-4" @click="close()">{{$t('Cancel')}}</button>
				</div>
			</template>
		</modal>
		<!-- Warning -->
		<modal
			size="small"
			@close="isPopupWarn = false"
			v-if="isPopupWarn">
			<template slot="header">
				{{ $t('Warning') }}
			</template>
			<template slot="body">
				{{ $t('This output is a shared output, the existing assigned rundown will be replaced') }}
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button
						class="btn btn-primary"
						@click="isPopupWarn = false">
						{{ $t('Ok') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import displaysApi from '@/api/displays';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import rundownsApi from '@/api/rundowns';

export default {
	name: 'ModalOutputDisplay',
	components: {
		Modal,
	},
	props: {
	},
	mounted() {
	},
	data: () => ({
		items: [],
		arrayDisplay: [],
		isSaving: false,
		rundownId: null,
		displayByRundown: [],
		displayIdByRundown: [],
		display: {
			id: null,
			rundown_id: null,
		},
		itemsDisplay: [],
		isFetching: false,
		isFetchingRundown: false,
		// render
		tab: 'output',
		displayRender: null,
		isToggleDisplay: false,
		selectedDisplayRender: null,
		keywordSearchDisplayRender: '',
		lastDisplayids: [],
		isPopupWarn: false,
	}),
	methods: {
		close() {
			this.arrayDisplay = [];
			this.itemsDisplay = [];
			this.$emit('close');
		},
		printLayerIndex(item) {
			const layerIndex = item && item.layer_index ? JSON.parse(item.layer_index) : null;
			if (Array.isArray(layerIndex) && layerIndex.length && !layerIndex.includes('0')) {
				return JSON.parse(item.layer_index).toString();
			}
			return 'All';
		},
		fetch() {
			this.isFetching = true;
			this.items = [];
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
			};
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				if (this.items.length > 0) {
					for (let index = 0; index < this.items.length; index++) {
						const display = {};
						display.id = this.items[index].id;
						display.rundown_id = this.items[index].rundown_id || null;
						this.arrayDisplay.push(duplicateVar(display));
						this.itemsDisplay.push(duplicateVar(display));
						// init default render size
						if (this.items[index].is_default) {
							this.selectedDisplayRender = this.items[index];
						}
					}
					const defaultRender = localStorage.getItem(`default_render_size_${this.user.id}`);
					if (defaultRender) this.selectedDisplayRender = JSON.parse(defaultRender);
				}
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: '',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		selectedDisplay(display) {
			if ((display && display.collaborators && display.collaborators.length > 0) || (this.user && display.user_id !== this.user.id)) this.isPopupWarn = true;
			const index = this.arrayDisplay.findIndex(({ id }) => id === display.id);
			this.lastDisplayids.push(display.id);
			if (index > -1) {
				const currentDisplay = this.arrayDisplay[index];
				if (currentDisplay.rundown_id === null) { // if rundown_id in array display null or empty
					currentDisplay.rundown_id = this.rundownId; // rundown_id in array display replaced by current rundowwn id
				} else if (currentDisplay.rundown_id !== this.rundownId) { // if rundown_id in array display not same as current rundown id
					currentDisplay.rundown_id = this.rundownId; // rundown_id in array display replaced by current rundowwn id
				} else if (currentDisplay.rundown_id === this.rundownId) { // if rundown_id in array display is same as current rundown id
					if (display.rundown_id !== this.rundownId) { // and if rundown_id in display data not same as current rundown id
						currentDisplay.rundown_id = display.rundown_id; // rundown id in array display replaced by rundown_id in display data
						this.lastDisplayids = this.lastDisplayids.filter(element => element !== display.id);
					} else { // and if rundown_id in display data is same as current rundown id
						this.lastDisplayids = this.lastDisplayids.filter(element => element !== display.id);
						currentDisplay.rundown_id = null; // rundown id in array display replaced by null
					}
				}
			}
		},
		select(close = true) {
			this.isSaving = true;
			const callback = (response) => {
				const message = response.message;
				const data = response.data;
				this.arrayDisplay = [];
				this.itemsDisplay = [];
				Object.assign(this.items, data);
				// update default render size
				if (this.selectedDisplayRender) this.updateDefaultDisplay();
				// communication between any components
				this.$root.$emit('updateDisplayOutput');
				// communication between iframe (live & preview)
				const iframeLiveDocument = document.getElementById('iframeLiveEditor');
				const iframePreviewDocument = document.getElementById('iframePreviewEditor');
				iframeLiveDocument.contentWindow.postMessage('updateOutput', '*');
				iframePreviewDocument.contentWindow.postMessage('updateOutput', '*');
				// notify success
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Displays',
					text: message,
				});
				this.isSaving = false;
				if (close) this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Device Monitor',
					text: message,
				});
				this.arrayDisplay = [];
				this.itemsDisplay = [];
				this.isSaving = false;
				this.close();
			};
			const rundownSlug = atob(this.activeRouteSlug);
			const params = {
				rundown_slug: rundownSlug,
				displays: JSON.stringify(this.arrayDisplay),
				last_display: this.lastDisplayids[this.lastDisplayids.length - 1],
			};
			displaysApi.removeRundown(params, callback, errorCallback);
		},
		getRundownData() {
			this.isFetchingRundown = true;
			this.rundownId = null;
			const callback = (response) => {
				const rundown = response.data;
				this.rundownId = rundown.id;
				this.arrayDisplay = [];
				if (this.items.length > 0) {
					for (let index = 0; index < this.items.length; index++) {
						const display = {};
						display.id = this.items[index].id;
						display.rundown_id = this.items[index].rundown_id;
						this.arrayDisplay.push(display);
					}
				}
				this.isFetchingRundown = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown',
					text: message,
				});
				this.isFetchingRundown = false;
			};
			rundownsApi.getBySlug(atob(this.activeRouteSlug), callback, errorCallback);
		},
		goToDisplay() {
			this.$emit('close');
			this.$router.push('/displays').catch(() => {});
		},
		viewDisplay(item) {
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `/displays/live/${btoa(item.slug)}/${btoa(item.id)}?${btoa('rundown_id=')}${rundownId}`;
			const routeData = this.$router.resolve({ path: url });
			window.open(routeData.href, '_blank');
		},
		trimDisplayName(str) {
			let result = '';
			if (str.length > 24) {
				result = `${str.substring(0, 24)}...`;
			} else {
				result = str;
			}
			return result;
		},
		toggleDisplay() {
			this.isToggleDisplay = true;
		},
		selectDisplay(item) {
			this.selectedDisplayRender = item;
			this.keywordSearchDisplayRender = '';
		},
		removeDisplay() {
			this.selectedDisplayRender = null;
		},
		switchTab(location) {
			if (location === 'output') {
				this.tab = 'output';
				this.isToggleDisplay = false;
			} else {
				this.tab = 'render';
			}
		},
		goToSubs() {
			this.$router.push('/settings?menu=subscribe').catch(() => {});
			this.close();
		},
		updateDefaultDisplay() {
			const params = {
				is_default: 1,
				user_id: this.user.id,
			};
			const callback = (response) => {
				const data = response.data;
				localStorage.setItem(`default_render_size_${this.user.id}`, JSON.stringify(data));
				// communication between any components
				// this.$root.$emit('updateDisplayOutput');
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Display',
					text: message,
				});
			};
			displaysApi.update(this.selectedDisplayRender.id, params, callback, errorCallback);
		},
		collaboratorList(item) {
			const collabResult = [];
			const collab = item && item.collaborators ? item.collaborators : '';
			for (let index = 0; index < collab.length; index++) {
				const element = collab[index].name;
				collabResult.push(` ${element}`);
			}
			return `Shared with ${collabResult}`;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		activeRouteSlug() {
			return this.$route.params.slug;
		},
		userRenderSequences() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			const userSubscription = settings && settings.subscription ? settings.subscription : null;
			const renderSequencesSetting = userSubscription && userSubscription.render_sequence ? userSubscription.render_sequence : null;
			const isRenderSequencesEnable = renderSequencesSetting && renderSequencesSetting.is_enabled ? renderSequencesSetting.is_enabled : false;
			return isRenderSequencesEnable;
		},
		filteredDisplay() {
			const filteredItems = this.items.filter(item => item.user_id === this.user.id);
			if (this.keywordSearchDisplayRender) {
				const finalResult = filteredItems.filter(item => item.name.toUpperCase().includes(this.keywordSearchDisplayRender.toUpperCase()));
				return finalResult;
			}
			return filteredItems;
		},
	},
	watch: {
	},
	created() {
		this.fetch();
		this.getRundownData();
	},
};
</script>
